export const fontSizeConfigModel = {
    options: [
        8,
        9,
        10,
        12,
        14,
        16,
        18,
        20,
        22,
        24,
        26,
        28,
        36,
        48,
        72
    ],
    supportAllValues: true
};
